import React, { useEffect, useState } from "react";
import { axiosClient } from "../AxiosClient";
import { Grid, styled } from "@mui/material";
import { TIPOS_MENSAJES } from "../../Constants";

const uploadImage = (keyImage, setImage) => {
        axiosClient.get(`/v1/s3/url/${keyImage}`)
        .then(response => {
            setImage(response.data);
        })
        .catch(error => {
            console.log("Error with Axios: " + error.message);
        });
    }

const HoraStyled = styled('span')({
    color: '#aaa', 
    fontSize: '10px', 
    position: 'absolute', 
    bottom: '8px',
    right: '5px',
});

export default function Video({videKey, tipos, times}) {
    const [video, setVideo] = useState();

    useEffect(() => {
        uploadImage(videKey, setVideo);
    }, []);

    return (
        <Grid item sx={{display: 'flex', justifyContent: tipos == TIPOS_MENSAJES.enviado ? 'flex-start' : 'flex-end', width: '100%'}}>
            <Grid sx={{position: 'relative', margin: '10px'}}>
                <video controls src={video}></video>
                <HoraStyled>{times}</HoraStyled>
            </Grid>
        </Grid>
    )
}